/*---

  Scripts for the collection page

  Louis-Charles Blais [info@22agencecreative.ca]

---*/



// Prevent default on page links
let pageLinks;
function handlePageLinks() {
  pageLinks = document.querySelectorAll('.collection-container .pagination a');
  for (let i = 0; i < pageLinks.length; i++) {
    pageLinks[i].addEventListener("click", function (e) {
      event.preventDefault();
      updateCollectionSection(pageLinks[i].href);
    });
  }
}
handlePageLinks();


// Page switcher
let sectionId = document.querySelector('.collection-container').dataset.shopifySectionId;
function updateCollectionSection(url) {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  
  fetch(url)
  .then((response) => response.text())
  .then((responseText) => {
    let newHtml = new DOMParser().parseFromString(responseText, 'text/html');
    document.querySelector('section.collection .collection-container').innerHTML = newHtml.querySelector('section.collection .collection-container').innerHTML;
    window.history.replaceState("", "", url);
    handleFiltersAndSorting();
    handlePageLinks();
  });
}


// Collection filters and sorting

let sortInput;
let filters;

function handleFiltersAndSorting() {
  sortInput = document.querySelector('.collection-container .sort-by');
  filters = document.querySelectorAll('.collection-container .sidebar input');
  sortInput.addEventListener("change", sortCollection);
  for (let i = 0; i < filters.length; i++) {
    filters[i].addEventListener("change", sortCollection);
  }
}
handleFiltersAndSorting();

function sortCollection() {
  let url = window.location.pathname + '?sort_by=' + sortInput.value;

  if (searchTerms != '') {
    url = url + '&q=' + searchTerms;
  }
  
  for (let i = 0; i < filters.length; i++) {
    if (filters[i].checked) {
      url = url + '&' + filters[i].name + '=' + filters[i].value;
    }
  }
  
  updateCollectionSection(url);
}